import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers";
import { styled } from "@mui/material";
import dayjs from "dayjs";
import { dateicon } from "../../utils/svgs/svgcode";

const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
}));

const TaskFilter = ({
  setTaskFilter,
  selectedStatus,
  setSelectedStatus,
  selectedCategory,
  setSelectedCategory,
  selectedDate,
  setSelectedDate,
  fetchdata,
  setIsFilterApplied,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  useEffect(() => {
    if (!selectedStatus) setSelectedStatus("All");
  }, []);

  // handle status/category click
  const handleButtonClick = (type, value) => {
    if (type === "status") {
      setSelectedStatus(value);
    } else if (type === "category") {
      setSelectedCategory((prev) =>
        prev.includes(value)
          ? prev.filter((c) => c !== value)
          : [...prev, value]
      );
    }
  };

  const handleApplyClick = () => {
    fetchdata({
      st: selectedStatus || "All",
      ct: selectedCategory || null,
      dt: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
    });
    setIsFilterApplied(true);
    setTaskFilter(false);
  };

  const handleClearClick = () => {
    setSelectedStatus("All");
    setSelectedCategory([]);
   const today = dayjs();
                 setSelectedDate(today);
    fetchdata({ st: null, ct: null, dt: null });
    setIsFilterApplied(false);
    setTaskFilter(false);
  };

  const handleDateChange = (date) =>{

   setSelectedDate(date);
   setIsCalendarOpen(false);
  }

  const buttonClass = (label) =>
    `px-6 py-2 rounded-3xl shadow-md ${
      selectedCategory.includes(label)
        ? "bg-[#E17954] text-white"
        : "bg-[#F3F3F3]"
    } text-black border border-gray-200`;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={() => setTaskFilter(false)}
    >
      <div
        className="bg-white rounded-lg lg:w-[50%] w-[90%] relative flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-3 pt-3">
          <h2 className="text-xl text-[#1D2951] font-inter">Tasks Filters</h2>
          <button
            onClick={() => setTaskFilter(false)}
            className="p-2 rounded-full"
          >
            <CloseIcon style={{ color: "#C7C7CB" }} />
          </button>
        </div>
        <hr className="my-1" />

        {/* Date Selector */}
        <div
          onClick={() => setIsCalendarOpen(!isCalendarOpen)}
          className="flex items-center justify-between m-3 px-2 py-1 border-2 w-[130px] shadow-md bg-white rounded-[10px] cursor-pointer relative"
        >
          <div className="text-sm flex flex-col items-start">
            {(() => {
              const today = new Date();
              const selected = selectedDate ? new Date(selectedDate) : today;
              const isToday = selected.toDateString() === today.toDateString();
              const formatted = `${String(selected.getMonth() + 1).padStart(
                2,
                "0"
              )}.${String(selected.getDate()).padStart(
                2,
                "0"
              )}.${selected.getFullYear()}`;
              return (
                <>
                  {isToday && (
                    <div className="text-[#1D2951] font-worksans font-medium text-[12px]">
                      Today
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <span className="font-normal text-[16px] text-[#3A3A49] font-worksans ">{formatted}</span>
                    {dateicon}
                  </div>
                </>
              );
            })()}
          </div>

          {isCalendarOpen && (
            <div       onClick={(e) => e.stopPropagation()} className="absolute left-0 top-12 z-10 bg-white shadow-md rounded-lg p-4">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDateCalendar
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </LocalizationProvider>
            </div>
          )}
        </div>

        {/* Status */}
        <div className="p-4 font-inter">
          <p className="text-[15px] text-[#979797] text-left mb-2">Status</p>
          <div className="flex gap-2 flex-wrap justify-start">
            {["All", "Pending", "Completed", "Cancelled Task"].map((status) => (
              <button
                key={status}
                onClick={() =>
                  handleButtonClick(
                    "status",
                    status === "Pending"
                      ? "INFO"
                      : status === "Completed"
                      ? "COMPLETED"
                      : status === "Cancelled Task"
                      ? "CANCELLEDTASK"
                      : "All"
                  )
                }
                className={`px-6 py-2 rounded-3xl shadow-md ${
                  selectedStatus === status ||
                  (status === "Pending" && selectedStatus === "INFO") ||
                  (status === "Completed" && selectedStatus === "COMPLETED") ||
                  (status === "Cancelled Task" &&
                    selectedStatus === "CANCELLEDTASK")
                    ? "bg-[#E17954] text-white"
                    : "bg-[#F3F3F3]"
                } border border-gray-200`}
              >
                {status}
              </button>
            ))}
          </div>

          {/* Category */}
          <p className="text-[15px] text-left text-[#979797] mt-6 mb-2">Category</p>
          <div className="flex gap-2 flex-wrap justify-start mt-2">
            {[
              "Labs",
              "Procedures",
              "Injections",
              "Schedule - RTO",
              "Referrals",
              "Refills",
              "Notes",
              "Medical-Records",
                'Diagnostic Tests'
            ].map((cat) => (
              <button
                key={cat}
                onClick={() => handleButtonClick("category", cat)}
                className={buttonClass(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-center gap-4 mt-4 mb-4">
          <button
            onClick={handleApplyClick}
            className="bg-[#50869A] px-12 py-2 rounded-3xl text-white"
          >
            Apply
          </button>
          <button
            onClick={handleClearClick}
            className="bg-[#50869A] px-12 py-2 rounded-3xl text-white"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskFilter;
